import React, { useEffect, useState } from "react";
import { get } from "../../../../utils/api";
import MultiColumns from "../MultiColumns";

import { companyId } from "../../../../utils/companyId";

const SupplyChain = ({ isEditing }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/social/supply_chain/${companyId}`);
        console.log("API response:", response.data);
        console.log(response.data, "response.data");
        // Update state only if data is available
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const questionary = [
    { mainheading: "Supplier Social Assessments", gridSize: { xs: 12 } },
    {
      question: "Number of suppliers assessed",
      key: "supplierSocialAssessments.numberOfSuppliersAssessed",
    },
    {
      key: "supplierSocialAssessments.percentageOfSuppliersAssessed.value",
      key2: "supplierSocialAssessments.percentageOfSuppliersAssessed.unit",
      question: "% of suppliers assessed",
    },
    {
      mainheading: "Fair Labor Practices in Supply Chain",
      gridSize: { xs: 12 },
    },
    {
      key: "fairLaborPractices",
      subkey: "numberOfSuppliersHavingFairLaborPractices",
      question: "No. of suppliers having fair labor practices",
    },
    {
      key: "fairLaborPractices",
      subkey: "numberOfSuppliersNotHavingFairLaborPractices",
      question: "No of suppliers not having fair labor practices",
    },
    {
      mainheading: "Child Labor Practices in Supply Chain",
      gridSize: { xs: 12 },
    },
    {
      key: "childLaborPractices",
      subkey: "numberOfSuppliersHavingFairLaborPractices",
      question: "No. of suppliers having fair labor practices",
    },
    {
      key: "childLaborPractices",
      subkey: "numberOfSuppliersNotHavingFairLaborPractices",
      question: "No of suppliers not having fair labor practices",
    },
  ];

  return (
    <>
      <MultiColumns
        title="SUPPLY CHAIN SOCIAL RESPONSIBILITY"
        questionary={questionary}
        columns={2}
        data={data}
        isEditing={isEditing}
        url={`/social/supply-chain`}
      />
    </>
  );
};

export default SupplyChain;
